import { TextArea as CarbonTextArea } from "@carbon/react";
import { InfoIcon } from "../../components";
// import { Controller } from "react-hook-form";

export const View = (props) => {
  const {
    control,
    errorMessage,
    register,
    iconRight,
    iconRightClassName,
    infoIconText,
    ...rest
  } = props;

  return (
    <div className={`input-container ${props.containerClassName}`}>
      <CarbonTextArea
        {...register(props.name)}
        // helperText={props.helperText}
        // placeholder={props.placeholder}
        {...rest}
        id={props.name}
        labelText={
          !props.label && !infoIconText ? (
            ""
          ) : (
            <div className="flex-container">
              <div className="flex-box">{props.label} </div>
              {infoIconText ? (
                <div className="ml-3">
                  <InfoIcon message={infoIconText} />{" "}
                </div>
              ) : null}
            </div>
          )
        }
        invalid={!!errorMessage}
        invalidText={errorMessage}
        className={`${props.className} switchapp-themed`}
      />

      {iconRight && (
        <div className={`input-icon-right ${iconRightClassName}`}>
          {iconRight}
        </div>
      )}
    </div>
  );
};
